module.exports = __webpack_public_path__ + "img/5-6.bd799eaf.png";